"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevenueSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var compositeChartCard_1 = require("../../charts/compositeChartCard");
var lineChartCard_1 = require("../../charts/lineChartCard");
var formatChartData_1 = require("../../../helpers/analytics/formatChartData");
var chartColors_1 = require("../../charts/chartColors");
var dashboardGrid_1 = require("../dashboardGrid");
exports.RevenueSection = (0, react_1.memo)(function (_a) {
    var _b, _c, _d, _e, _f;
    var data = _a.data, loading = _a.loading, top_branches = _a.top_branches, top_branches_loading = _a.top_branches_loading, top_earners = _a.top_earners, top_earners_loading = _a.top_earners_loading;
    var currency = (data === null || data === void 0 ? void 0 : data.currency) || "ZAR";
    var compositeData = (function () {
        var _a;
        if (!data)
            return [];
        var base = (0, formatChartData_1.formatCompositeData)(data.time_series);
        if ((_a = data.prev_time_series) === null || _a === void 0 ? void 0 : _a.length) {
            var prev_1 = data.prev_time_series;
            return base.map(function (row, index) { var _a, _b; return (__assign(__assign({}, row), { prev_value: (_b = (_a = prev_1[index]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null })); });
        }
        return base;
    })();
    var hasPrev = !!((_b = data === null || data === void 0 ? void 0 : data.prev_time_series) === null || _b === void 0 ? void 0 : _b.length);
    var revenueByType = data ? (0, formatChartData_1.formatTypeBreakdown)(data.by_type) : [];
    var aovData = (function () {
        var _a, _b;
        if (!((_a = data === null || data === void 0 ? void 0 : data.time_series) === null || _a === void 0 ? void 0 : _a.length))
            return [];
        var prev = (_b = data.prev_time_series) !== null && _b !== void 0 ? _b : [];
        return data.time_series.map(function (point, index) {
            var _a, _b;
            var count = (_a = point.count) !== null && _a !== void 0 ? _a : 0;
            var prevPoint = prev[index];
            var prevCount = (_b = prevPoint === null || prevPoint === void 0 ? void 0 : prevPoint.count) !== null && _b !== void 0 ? _b : 0;
            return {
                date: (0, formatChartData_1.formatBucketLabel)(point.date),
                aov: count > 0 ? Math.round((point.value / count) * 100) / 100 : 0,
                prev_aov: prevPoint && prevCount > 0 ? Math.round((prevPoint.value / prevCount) * 100) / 100 : null,
            };
        });
    })();
    var hasPrevAov = aovData.some(function (point) { return point.prev_aov !== null; });
    var cumulativeData = (function () {
        var _a;
        if (!((_a = data === null || data === void 0 ? void 0 : data.time_series) === null || _a === void 0 ? void 0 : _a.length))
            return [];
        var running = 0;
        return data.time_series.map(function (point) {
            running += point.value;
            return { date: (0, formatChartData_1.formatBucketLabel)(point.date), value: Math.round(running * 100) / 100 };
        });
    })();
    var topBranchesData = (_d = (_c = top_branches === null || top_branches === void 0 ? void 0 : top_branches.items) === null || _c === void 0 ? void 0 : _c.map(function (branch) { return ({
        name: branch.branch.length > 22 ? "".concat(branch.branch.slice(0, 22), "\u2026") : branch.branch,
        rewards: Math.round(branch.rewards_issued * 100) / 100,
        events: branch.earning_events,
        players: branch.unique_players,
    }); })) !== null && _d !== void 0 ? _d : [];
    var topEarnersData = (_f = (_e = top_earners === null || top_earners === void 0 ? void 0 : top_earners.items) === null || _e === void 0 ? void 0 : _e.map(function (earner) { return ({
        name: (earner.user_name || earner.user_id || "—").length > 24
            ? "".concat((earner.user_name || earner.user_id || "—").slice(0, 24), "\u2026")
            : earner.user_name || earner.user_id || "—",
        rewards: Math.round(earner.rewards_issued * 100) / 100,
        events: earner.earning_events,
    }); })) !== null && _f !== void 0 ? _f : [];
    var widgets = [
        {
            i: "composite_chart",
            x: 0,
            y: 0,
            w: 6,
            h: 4,
            title: "Rewards Issued & Earning Events",
            tooltip: "Rewards Issued = total loyalty currency paid out (Earn + Cashback + Reversal). Earning Events = number of grant events logged.",
            content: ((0, jsx_runtime_1.jsx)(compositeChartCard_1.CompositeChartCard, { title: "Rewards Issued & Earning Events", data: compositeData, lineKeys: __spreadArray([
                    { key: "value", name: "Rewards Issued", color: chartColors_1.chartColors.success.base, yAxisId: "left" }
                ], (hasPrev
                    ? [{ key: "prev_value", name: "Rewards Issued (prev)", color: chartColors_1.chartColors.success.faded, yAxisId: "left", dashed: true }]
                    : []), true), barKeys: [{ key: "count", name: "Earning Events", color: chartColors_1.chartColors.secondary.faded, yAxisId: "right" }], xAxisKey: "date", dualYAxis: true, noCard: true, loading: loading })),
        },
        {
            i: "aov_trend",
            x: 6,
            y: 0,
            w: 6,
            h: 4,
            title: "Average Reward Per Earning",
            tooltip: "Total Rewards Issued ÷ earning event count per day. Mean reward value paid out per loyalty grant.",
            content: ((0, jsx_runtime_1.jsx)(lineChartCard_1.LineChartCard, { title: "Average Reward Per Earning", data: aovData, dataKeys: __spreadArray([
                    { key: "aov", name: "Avg / earning", color: chartColors_1.chartColors.success.base }
                ], (hasPrevAov
                    ? [{ key: "prev_aov", name: "Avg / earning (prev)", color: chartColors_1.chartColors.success.faded, dashed: true }]
                    : []), true), xAxisKey: "date", noCard: true, loading: loading })),
        },
        {
            i: "cumulative",
            x: 0,
            y: 4,
            w: 6,
            h: 4,
            title: "Cumulative Rewards Issued",
            tooltip: "Running total of rewards issued across the selected period. Shows pace of loyalty spend.",
            content: ((0, jsx_runtime_1.jsx)(lineChartCard_1.LineChartCard, { title: "Cumulative Rewards Issued", data: cumulativeData, dataKeys: [{ key: "value", name: "Cumulative (".concat(currency, ")"), color: chartColors_1.chartColors.success.base }], xAxisKey: "date", noCard: true, loading: loading })),
        },
        {
            i: "type_chart",
            x: 6,
            y: 4,
            w: 6,
            h: 4,
            title: "Rewards by Earning Type",
            tooltip: "Rewards Issued grouped by type. Earn = points/cashback grants. Cashback = order-based cashback. Reversal = refunded grants.",
            content: ((0, jsx_runtime_1.jsx)(compositeChartCard_1.CompositeChartCard, { title: "Rewards by Earning Type", data: revenueByType.map(function (item) { return ({ type: item.name, value: item.value }); }), barKeys: [{ key: "value", name: "Rewards Issued" }], xAxisKey: "type", layout: "vertical", noCard: true, loading: loading })),
        },
        {
            i: "top_branches",
            x: 0,
            y: 8,
            w: 6,
            h: 4,
            title: "Top Branches by Rewards Issued",
            tooltip: "Branches ranked by total rewards paid out in the period. Branches without a location tag fall into 'Unattributed'.",
            content: ((0, jsx_runtime_1.jsx)(compositeChartCard_1.CompositeChartCard, { title: "Top Branches by Rewards Issued", data: topBranchesData, barKeys: [{ key: "rewards", name: "Rewards (".concat(currency, ")"), color: chartColors_1.chartColors.success.base }], xAxisKey: "name", layout: "vertical", noCard: true, loading: top_branches_loading })),
        },
        {
            i: "top_earners",
            x: 6,
            y: 8,
            w: 6,
            h: 4,
            title: "Top Members by Rewards Received",
            tooltip: "Members who received the most loyalty currency in the period.",
            content: ((0, jsx_runtime_1.jsx)(compositeChartCard_1.CompositeChartCard, { title: "Top Members by Rewards Received", data: topEarnersData, barKeys: [{ key: "rewards", name: "Rewards (".concat(currency, ")"), color: chartColors_1.chartColors.secondary.base }], xAxisKey: "name", layout: "vertical", noCard: true, loading: top_earners_loading })),
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-bold text-foreground", children: "Rewards Issued & Earnings" }), (0, jsx_runtime_1.jsx)(dashboardGrid_1.DashboardGrid, { widgets: widgets })] }));
});
exports.RevenueSection.displayName = "RevenueSection";
